import React from "react";
import { Link } from 'react-router-dom';
import footlogoimg from "../assets/images/GuideUni_logo_white.png";

const Footer = () => {
    return (
        <div class="footer footer-bg-1">
            <div class="need-help">
    <div class="container-fluid">
      <div class="container pt-3 pb-3">
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <div class="kmd-text">
             Get Started with GuideUni
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <ul class="kmd-list">
              <li>
                <a >Sign Up for Free</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
 <div class="footer footer-bg-1">
    <div class="container-fluid">
      <div class="container pt-3">
        <div class="row">
          <div class="col-md-6 col-sm-12 footer-logo">
            <a href="index.html"><img src={footlogoimg} alt="" /></a>
          </div>
          <div class="col-md-6 col-sm-12">
             <ul class="footer-list-right-align">
              <li>
                <Link to="/contact">
                                         Contact Us
                                       </Link>
              </li>
              <li>
                <a href="#"><i class="ri-sign-fill"></i> Sign In </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">

            <div class="row">
              <div class="col-md-12">
                <p class="pt-3">With GuideUni, universities gain a powerful platform designed to make international
                  student recruitment seamless and efficient.</p>

              </div>
              <div class="col-md-12">
                <ul class="fot-list-media">
                  <li>
                    <a href="javascript:void(0)">
                      <i class="ri-facebook-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="ri-twitter-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="ri-instagram-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="ri-linkedin-fill"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="ri-youtube-fill"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div>

            </div>
          </div>
          <div class="col-md-8 col-sm-12">
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <h3 class="display-6">Platform</h3>
                <ul class="fot-list-v-one">
                  <li>
                 <Link to="/universities">Universities</Link>
                  </li>
                  <li>
                    <Link to="/recruiters">Recruiters</Link>
                  </li>
                  <li>
                   <Link to="/aggregators">Aggregators</Link>
                  </li>
                </ul>
              </div>
              <div class="col-md-4 col-sm-12">
                <h3 class="display-6">Resource Center</h3>
                <ul class="fot-list-v-one">
                  <li>
                     <Link to="/how-it-works">
                                             How It Works
                                           </Link>
                  </li>
                  {/* <!-- <li>
                    <a href="price.html">Pricing</a>
                  </li> --> */}
                  <li>
                     <Link to="/blog">
                                             Blog
                                           </Link>
                  </li>
                </ul>
              </div>
              <div class="col-md-4 col-sm-12">
                <h3 class="display-6">Company</h3>
                <ul class="fot-list-v-one">
                  <li>
                     <Link to="/about">
                                             About Company
                                           </Link>
                  </li>
                  <li>
                   <Link to="/career">
                                           Careers
                                         </Link>
                  </li>
                  <li>
                     <Link to="/contact">
                          Contact Us
                        </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="container-fluid footer-bg-2">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-12 ">
            <span class="pt-c-10 d-block copy-r-text">© 2026 GuideUni. All Rights Reserved.</span>
          </div>
         <div className="col-md-6 col-sm-12">
                <ul className="fot-list-h-two">
                  <li>
                    <a href="/privacy-policy">Privacy-Policy </a>
                  </li>
                  <li>
                    <a href="/cookie-policy">Cookie-Policy </a>
                  </li>
                  <li>
                    <a href="/payment-terms">Payment Terms</a>
                  </li>
                </ul>
              </div>
        </div>
      </div>
    </div>
  </div>
        </div>
    );
};

export default Footer;
